import {createAction} from 'redux-actions'

const action = name => createAction(`my-company-star/${name}`)

export const addCompany = action('ADD_COMPANY')
export const removeCompany = action('REMOVE_COMPANY')
